// @flow

import React from "react";

import { isNil } from "ramda";

import {
  SelecaoDeflacao,
  SelecaoNormalizacao,
  SelecaoCorrecaoMonetaria,
} from "../configuracoes";
import {
  ID_FONTE_FIDC_PADRAO,
  ID_OPCAO_DEFLATOR_NENHUM,
  ID_OPCAO_CORRETOR_MONETARIO_NENHUM,
  type MedidaSelecionada,
} from "../../../model";
import {
  type State,
  getEdicaoMedida,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
} from "../../../state";

export const processarSeriesComFonteDeflatorCorrecao = (
  state: State,
  medidas: Array<MedidaSelecionada>
): Array<MedidaSelecionada> => {
  const edicaoMedida = getEdicaoMedida(state);
  const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

  return medidas.map(medida => {
    const configCorrecao =
      exibirConfiguracoesAvancadas &&
      !isNil(edicaoMedida.corretorMonetario) &&
      edicaoMedida.corretorMonetario !== ID_OPCAO_CORRETOR_MONETARIO_NENHUM
        ? {
            correcaoMonetaria: edicaoMedida.corretorMonetario,
          }
        : {};
    const configDeflator =
      exibirConfiguracoesAvancadas &&
      !isNil(edicaoMedida.deflator) &&
      edicaoMedida.deflator !== ID_OPCAO_DEFLATOR_NENHUM
        ? {
            deflator: edicaoMedida.deflator,
          }
        : {};

    const configValorDataBase =
      exibirConfiguracoesAvancadas &&
      !isNil(edicaoMedida.valorBaseDeflator) &&
      !isNil(edicaoMedida.dataBaseDeflator)
        ? {
            valorBaseDeflator: edicaoMedida.valorBaseDeflator,
            valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
            dataBaseDeflator: edicaoMedida.dataBaseDeflator,
            dataBaseDeflatorDataEspecifica:
              edicaoMedida.dataBaseDeflatorDataEspecifica,
          }
        : {};

    return {
      ...medida,
      fonteDeDadosFIDC: ID_FONTE_FIDC_PADRAO,
      ...configCorrecao,
      ...configDeflator,
      ...configValorDataBase,
      ...analiseValorDaMedida(medida, state),
    };
  });
};

const SeriesComFonteDeflatorCorrecao = () => {
  return (
    <div className="ConfiguracaoMedida--row">
      <div className="ConfiguracaoMedida__group">
        <div className="ConfiguracaoMedida__box">
          <SelecaoDeflacao exibirNormalizacao={false} />
        </div>
      </div>
      <div className="ConfiguracaoMedida__group">
        <div className="ConfiguracaoMedida__box">
          <SelecaoCorrecaoMonetaria />
        </div>
      </div>
      <div className="ConfiguracaoMedida__group">
        <div className="ConfiguracaoMedida__box">
          <SelecaoNormalizacao
            forcarExibirNormalizacao={true}
            exibirOpcaoNenhum={true}
          />
        </div>
      </div>
    </div>
  );
};

export default SeriesComFonteDeflatorCorrecao;
